import * as React from 'react'
import { cn } from '@/utils/cn'

export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type = 'text', ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    className={cn(
      'min-h-11 w-full rounded-v2-sm border border-v2-border bg-v2-surface px-3 text-base text-v2-ink placeholder:text-v2-ink-soft focus-visible:border-v2-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-v2-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  />
))
Input.displayName = 'Input'
